module.exports = __webpack_public_path__ + "3090097f.png";